<template>
    <div class="account">
        <div class="top wbg">
            <a-row :gutter="40" type="flex">
                <a-col :span="5" class="col" v-if="user.id == 1">
                    <label>账号名称：</label>
                    <a-input v-model="form.account" placeholder="请输入账号名称" style="width:100%;"></a-input>
                </a-col>
                <a-col :span="5" class="col">
                    <label>IP地址：</label>
                    <a-input v-model="form.login_ip" placeholder="请输入ip地址" style="width:100%;"></a-input>
                </a-col>
                <a-col :span="7" class="col">
                    <label>登录时间：</label>
                    <timePick style="width: 100%;" @PickTime="PickTime" ref="timePicker"></timePick>
                </a-col>
                <a-col :span="5" class="col">
                    <a-button type="primary" icon="search" @click="form.page = 1; query()" style="margin-right:20px;height: 32px;">查询</a-button>
                    <a-button @click="reset" style="margin-right:20px;height: 32px;">重置</a-button>
                </a-col>
            </a-row>
        </div>
        <div class="tcon wbg">
            <div class="tableList">
                <table class="table" style="table-layout: fixed;">
                    <thead class="thead">
                        <td>账号名称</td>
                        <td>IP地址</td>
                        <td>登录地址</td>
                        <td>登录时间</td>
                    </thead>
                    <tbody>
                        <tr v-for='i in list' :key='i.id'>
                            <td>
                                <p>
                                    {{ i.account || '/' }}
                                </p>
                            </td>
                            <td>
                                <p>
                                    {{ i.login_ip }}
                                </p>
                            </td>
                            <td>
                                <p>{{ i.login_location }}</p>
                            </td>
                            <td>
                                <p>
                                    {{ i.login_time }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="pages" v-if="count > 10">
                    <a-pagination v-model="form.page" show-quick-jumper :total="count" show-less-items :pageSize='10'
                        @change='turnpage' />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { userLog } from '@/server/user'
export default {
    data() {
        return {
            accuserList: [],
            list: [],
            count: 0,
            auditTime: '',
            form: {
                account: '',
                login_ip: '',
                end_time: '',
                start_time: '',
                page: 1,
                limit: 10
            },
            modalVisible: false,
        }
    },
    filters: {

    },
    created() {
        this.query()
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    mounted() {
        let _this = this
        document.onkeydown = function (e) {
            if (e.keyCode == 13) {
                _this.query()
            }
        }
    },
    methods: {
        dbclick(record) {
            if (this.$common.AUTH('debtor:info')) {
                if (record.debtor_id) {
                    let routeUrl = this.$router.resolve({ "name": "lydetails", params: { "id": record.debtor_id } });
                    window.open(routeUrl.href, '_blank');
                }

            }
            else {
                this.$message.error({ content: '暂无权限', key: 'updatable' });
            }
        },
        PickTime(e) {
            if ("start_time" in e) {
                this.form.start_time = e.start_time
            }
            else {
                this.form.end_time = e.end_time
            }
        },
        turnpage(val) {
            this.form.page = val;
            this.query()
        },
        reset() {
            if(this.user.id == 1){
                this.form.account = ''
            }
            this.form.start_time = ''
            this.form.end_time = ''
            this.$refs.timePicker.clearTime()
            this.form.login_ip = ''
            this.form.limit = 10
            this.form.page = 1
            this.query()
        },
        query() {
            const form = JSON.parse(JSON.stringify(this.form))
            userLog(form).then((res) => {
                console.log(res);
                this.list = res.list;
                this.count = res.count
            })
        }
    }
}
</script>
<style lang="less" scoped>
.col {
    display: flex;
    align-items: center;

    label {
        white-space: nowrap;
    }
}

.account {
    .top {
        padding: 20px;

        .group {
            display: flex;
            align-items: center;
        }

        .to {
            display: inline-block;
            width: 20px;
            height: 1px;
            margin: 0 10px;
            background-color: #dbdcde;
            vertical-align: middle;
        }

        form {
            width: 100%;
        }

        .label {
            display: inline-block;
            margin-right: 60px;
            font-size: 14px;
            color: #0e2949;
        }

        .btns {
            float: right;

            button {
                margin-left: 20px;
                min-width: 90px;
            }
        }
    }
}

// .ant-btn {
//     border-color: #1d8bfe;
//     color: #1d8bfe;
// }

.ant-btn-primary {
    color: #ffffff;
    border-color: #1d8bfe;
    background-color: #1d8bfe;
}

.tcon {
    padding: 0 20px;
    min-height: 760px;

    .tableList {
        width: 100%;

        .table {
            thead {
                td {
                    padding-left: 0;

                    &:nth-child(1) {
                        padding-left: 20px;
                    }
                }
            }

            tbody {
                tr:nth-last-child(1) {
                    border-bottom: 1px solid #ebebeb;
                }

                td {
                    .del {
                        margin-left: 20px;
                    }

                    padding: 6px 0;
                    height: 60px;

                    &:nth-child(1) {
                        padding-left: 20px;
                    }

                    p,
                    .p {
                        padding: 10px 0;
                        margin: 0;
                        border-bottom: 1px solid #ebebeb;

                        &:nth-last-child(1) {
                            border: 0 none;
                        }
                    }
                }
            }
        }
    }
}

.modal-footer {
    text-align: center;

    .cancel {
        background-color: #b2c9e1;
        border-color: #b2c9e1;
        margin-left: 30px;
    }
}

.pages {
    text-align: right;
}
</style>
